/*
 * @Author: zyy
 * @Date: 2022-03-28 10:51:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-07-17 10:40:47
 * @Description: 商城拦截器配置:post需要设置为form-tada格式
 */
import axios from 'axios';
import router from '@/router';
import qs from 'qs'
import Message from 'ant-design-vue/lib/message';

import {
  $getCookie
} from '@/plugins/utils.js';

import '@/assets/js/pace.min.js';

const $downloadFile = (content, name) => {
  const blob = new Blob([content]);
  const fileName = name;
  if ('download' in document.createElement('a')) { // 非IE下载
    const link = document.createElement('a');
    link.download = fileName;
    link.style.display = 'none';
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(link.href); // 释放URL 对象
    document.body.removeChild(link);
  } else { // IE10+下载
    navigator.msSaveBlob(blob, fileName);
  }
}

// 初始化Pace
window.paceOptions = {
  ajax: {
    trackMethods: ["GET", "POST", "DELETE", "PUT", "PATCH"]
  }
};

Pace.on("hide", () => {
  Pace.stop();
});

let shopRequests = axios.create({
  timeout: 6000,
  // 设置请求头
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

shopRequests.defaults.baseURL = process.env.VUE_APP_DOMAIN;

shopRequests.interceptors.request.use(
  config => {
    const token = $getCookie('token');
    const communityId = $getCookie('communityId');
    const setHeaders = (name, value) => {
      config.headers[name] = value;
    };
    if (token) {
      setHeaders('Authorization', token);
    }
    if (communityId) {
      setHeaders('X-COMMUNITY-ID', communityId);
    }
    // 转换
    config.data = qs.stringify(config.data)
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

shopRequests.interceptors.response.use(
  res => {
    if (res.config.responseType === 'blob') {
      $downloadFile(res.data, res.headers['content-disposition'].split('filename=')[1]);
    }
    if (res.data.code) {
      if (res.data.code == 1 && res.data.msg != '') {
        Message.success(res.data.msg)
        return res.data
      } else {
        // alert(res.data.msg)
      }
    }
    return res.data;
  },
  err => {
    if (err.response) {
      let status = err.response.status;
      let message = err.response.data.message || '未知错误';
      if (status === 401) {
        router.push('/entrance');
      } else if (status === 403) {
        router.push('/no_auth');
      } else if (status === 500) {
        router.push('/mistake');
      }
      Message.error({ content: message, key: 'tips', duration: 1 });
    }



    return Promise.reject(err);
  }
);
export default shopRequests